export interface IProjectReport {
  id: number;
  code: string;
  name: string;
}
